export default __webpack_public_path__ + "static/media/ic_whatsapp.b113c9cf.svg";